import { appConfig } from '@/app/config/appConfig';
import type { DemoLevel } from '@/types/sliding-puzzle';

const PREVIEW_DISPLAY_TIME_SECONDS = 3;

interface PreviewApiResponse {
  success: boolean;
  message?: string;
  data: {
    id: string;
    name: string;
    level: {
      id: string;
      name: string;
    };
    gridSize: { x: number; y: number };
    fullImageUrl: string;
    shuffles: Array<{
      id: string;
      pieces: number[];
    }>;
  };
}

export async function fetchPreviewLevel(boardId: string, token: string): Promise<DemoLevel> {
  const response = await fetch(
    `${appConfig.game.apiUrl}/v1/boards/details?boardId=${encodeURIComponent(boardId)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch preview board: ${String(response.status)}`);
  }

  const body = (await response.json()) as PreviewApiResponse;
  if (!body.success) {
    throw new Error(body.message ?? 'Failed to fetch preview board');
  }

  const d = body.data;
  return {
    levelName: d.name,
    boards: d.shuffles.map((shuffle) => ({
      id: shuffle.id,
      gridSize: d.gridSize,
      fullImageUrl: d.fullImageUrl,
      displayTime: PREVIEW_DISPLAY_TIME_SECONDS,
      initialPieces: shuffle.pieces,
    })),
  };
}
